"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var expressionsOfInterestStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        sectionTitle: {
            fontWeight: 'bold',
            color: palette.common.black,
            display: 'inline-block',
            margin: '10px 0',
        },
        container: {
            padding: '10px 0',
            borderBottom: "1px solid " + palette.primaryDisabled.main,
        },
    });
}, { name: 'GqlSummary_ExpressionsOfInterest' });
exports.default = expressionsOfInterestStyles;
